import certificate1 from '../assets/certificates/Functions, Methods, and Interfaces in Go.pdf'
import certificate2 from '../assets/certificates/interview.pdf'
import certificate3 from '../assets/certificates/Introduction to Project Management.pdf'
import certificate4 from '../assets/certificates/ios.pdf'
import certificate5 from '../assets/certificates/programming fundamental swift.pdf'
import certificate6 from '../assets/certificates/Project Management Foundations, Initiation, and Planning.pdf'
import certificate7 from '../assets/certificates/Starting with GO.pdf'
import certificate8 from '../assets/certificates/version controller.pdf'

export const certificates = [
  {
    title: 'Functions, Methods, and Interfaces in Go',
    issuer: 'University of California, Irvine',
    date: '2025',
    file: certificate1,
    description:
      'Completed Coursera training focused on Go functions, methods, interfaces, and struct-based programming for building modular and maintainable applications.'
  },
  {
    title: 'Coding Interview Preparation',
    issuer: 'Meta',
    date: '2024',
    file: certificate2,
    description:
      'Completed Coursera training in coding interview strategies, algorithmic problem solving, data structures, and technical communication for software engineering interviews.'
  },
  {
    title: 'Introduction to Project Management',
    issuer: 'IBM',
    date: '2024',
    file: certificate3,
    description:
      'Completed Coursera training covering project management fundamentals, planning concepts, team coordination, project life cycles, and stakeholder communication.'
  },
  {
    title: 'Introduction to iOS Mobile Application Development',
    issuer: 'Meta',
    date: '2024',
    file: certificate4,
    description:
      'Completed Coursera training introducing iOS application development, mobile app structure, Apple development tools, and core concepts for building iOS interfaces.'
  },
  {
    title: 'Programming Fundamentals in Swift',
    issuer: 'Meta',
    date: '2024',
    file: certificate5,
    description:
      'Completed Coursera training focused on Swift programming fundamentals, including syntax, variables, control flow, functions, and foundations for iOS development.'
  },
  {
    title: 'Project Management Foundations, Initiation, and Planning',
    issuer: 'SkillUp EdTech',
    date: '2024',
    file: certificate6,
    description:
      'Completed Coursera training on project initiation, scope definition, planning workflows, scheduling, risk awareness, and structured project execution.'
  },
  {
    title: 'Getting Started with Go',
    issuer: 'University of California, Irvine',
    date: '2024',
    file: certificate7,
    description:
      'Completed Coursera training introducing Go programming fundamentals, including basic syntax, variables, functions, packages, and command-line development workflows.'
  },
  {
    title: 'Version Control',
    issuer: 'Meta',
    date: '2024',
    file: certificate8,
    description:
      'Completed Coursera training in Git-based version control, repository workflows, branching, merging, collaboration practices, and source code management.'
  }
]